/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { CHeader, CToggler, CHeaderBrand, CHeaderNav } from "@coreui/react";
import banner from "../../src/assets/images/cgmfpfed_logo1-1.gif";
import smlogo from "../../src/assets/images/logoImg.png";
import { TheHeaderDropdown, TheHeaderDropdownNotif } from "./index";
const TheHeader = (props) => {
  const dispatch = useDispatch();
  const sidebarShow = useSelector((state) => state.sidebarShow);

  const toggleSidebar = () => {
    const val = [true, "responsive"].includes(sidebarShow)
      ? false
      : "responsive";
    dispatch({ type: "set", sidebarShow: val });
  };

  const toggleSidebarMobile = () => {
    const val = [false, "responsive"].includes(sidebarShow)
      ? true
      : "responsive";
    dispatch({ type: "set", sidebarShow: val });
  };

  return (
    <CHeader withSubheader>
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CToggler
        inHeader
        className="ml-3 d-md-down-none"
        onClick={toggleSidebar}
      />
      <CHeaderBrand className="mx-auto d-lg-none " to="/">
        {/* className="p-3" */}
        <img
          // src={"avatars/logoImg.png"}
          src={smlogo}
          alt="Logo"
        />
      </CHeaderBrand>
      <CHeaderBrand
        className="d-md-down-none  mx-auto "
        // style={{ height: "7.5rem" }}
      >
        <img src={banner} className="img-fluid " />
      </CHeaderBrand>

      {/* className="px-3" */}
      <CHeaderNav>
        <TheHeaderDropdownNotif />
        <TheHeaderDropdown />
      </CHeaderNav>
    </CHeader>
  );
};
export default TheHeader;
